import { IReactionDisposer, observable, reaction, runInAction, when } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Modal } from 'telia-front-react';
import MovieDetailsStore from '../stores/movierental/MovieDetailsStore';
import RouteStore from '../stores/RouteStore';
import MovieDetailsContainer from './MovieDetailsContainer';
import { withAnalytics } from '../util/AnalyticsUtil';

interface TvModalProps {
  rootCategoryId: string;
  isFreeOfCharge?: boolean;
  specialPricePacketIds?: number[];
  movieDetailsStore?: MovieDetailsStore;
  routeStore?: RouteStore;
  pushAnalytics?: (data: string) => void;
}

@observer
class TvModal extends React.Component<TvModalProps> {
  @observable accessor modalOpen: boolean = false;

  private queryParamsReactionDisposer: IReactionDisposer;

  public componentDidMount() {
    const { movieDetailsStore, pushAnalytics, routeStore } = this.props;
    this.queryParamsReactionDisposer = reaction(
      () => routeStore.decodedParams,
      () => {
        if (movieDetailsStore.openMovieModalByParams()) {
          this.modalOpen = true;
          const { selectedItemId, selectedItemType } = movieDetailsStore;
          movieDetailsStore.loadMovieDetails(selectedItemId, selectedItemType);
          when(
            () => !movieDetailsStore.isFetchingMovieDetails(selectedItemId, selectedItemType),
            () => pushAnalytics(`Modal - ${movieDetailsStore.getMovieDetails(selectedItemId, selectedItemType)?.title}`)
          );
        }
      },
      { fireImmediately: true }
    );
  }

  public componentWillUnmount() {
    const { movieDetailsStore } = this.props;
    if (this.modalOpen) {
      movieDetailsStore.closeModal();
    }
    this.queryParamsReactionDisposer();
  }

  private closeModal = () => {
    runInAction(() => {
      const { routeStore, movieDetailsStore } = this.props;
      movieDetailsStore.closeModal();
      routeStore.replace(window.location.href.split('?')[0]);
    });
  };

  public render() {
    const { movieDetailsStore, isFreeOfCharge, rootCategoryId, specialPricePacketIds } = this.props;

    return (
      <Modal
        isOpen={this.modalOpen && movieDetailsStore.modalOpen && !!movieDetailsStore.selectedItemId}
        onClose={this.closeModal}
        cover={movieDetailsStore.modalCover}
        hasContentComponent={true}
      >
        <MovieDetailsContainer
          movieId={movieDetailsStore.selectedItemId}
          type={movieDetailsStore.selectedItemType}
          isFreeOfCharge={isFreeOfCharge}
          rootCategoryId={rootCategoryId}
          specialPricePacketIds={specialPricePacketIds}
        />
      </Modal>
    );
  }
}

export default inject('movieDetailsStore', 'routeStore')(withAnalytics(TvModal));
